const isHex = (str) => /^.*#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/i.test(str);
const isRgbOrRgba = (str) => /(.*?)(rgb|rgba)\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/i.test(str);
function hexToRgb(hex) {
    const shorthandRegex = /^.#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
    const result = /^.#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
}
const rgbaToPureRgb = (r) => {
    const result = /(.*?)(rgb|rgba)\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/i.exec(r);
    return result
        ? {
            r: parseInt(result[3], 10),
            g: parseInt(result[4], 10),
            b: parseInt(result[5], 10),
        }
        : null;
};
export const parseToRGB = (input) => {
    switch (true) {
        case isHex(input):
            return hexToRgb(input);
        case isRgbOrRgba(input):
            return rgbaToPureRgb(input);
        default:
            return null;
    }
};
//# sourceMappingURL=parse-color.js.map